(function () {
    angular.module('tmx-app').controller('callingReportCtrl', [
        '$mdSidenav',
        'tmxUtility',
        'menu',
        '$mdMedia',
        'resolvedData',
        'BranchService',
        'CallingReportService', 'UsersService',

        function CallingReportCtrl(
            $mdSidenav,
            tmxUtility,
            menu,
            $mdMedia,
            resolvedData,
            BranchService,
            CallingReportService, UsersService
        ) {
            var CallingReportVM = this;
            CallingReportVM.menu = menu;
            CallingReportVM.gridData = new kendo.data.ObservableArray([]);
            // CallingReportVM.checkPermission = PrivilegesService.checkPermission;
            CallingReportVM.search = search;
            CallingReportVM.filterEnabled = false;
            // CallingReportVM.disableExport = true;
            CallingReportVM.toggle = toggle;
            CallingReportVM.isOpen = isOpen;
            var exportUserId = null;
            var exportFromDate = null;
            var exportToDate = null;
            CallingReportVM.Roles = resolvedData.RoleLov.data;
            CallingReportVM.clear = clear;
            CallingReportVM.formatColumnName = tmxUtility.formatColumnName;
            CallingReportVM.formatDateTime=tmxUtility.formatDateTimeForCompany;
            CallingReportVM.selectedRole = CallingReportVM.Roles.filter(function (item) {
                return item.VisibleValue == "VOT";
            })[0].HiddenValue;

            function isOpen(navID) {
                return $mdSidenav(navID).isOpen();
            }
            function clear() {
                //   CallingReportVM.disableExport = true;
                CallingReportVM.LoanApplicationNumber = null;
                CallingReportVM.BranchId = null;
                CallingReportVM.NationalId = null;
                CallingReportVM.FromDate = null;
                CallingReportVM.ToDate = null;
                CallingReportVM.container.CallingReportGrid.dataSource.read();
            }


            CallingReportVM.OnRoleSelected = function (roleId) {
                if (tmxUtility.exists(roleId)) {
                    UsersService.getUserByRole(roleId).then(function (response) {
                        CallingReportVM.UserList = response.data;

                        CallingReportVM.UserList.forEach(function (item) {
                            item.HiddenValue = item.UserID;
                            item.VisibleValue = item.UserName;
                        })

                    });
                }
            }

            BranchService.getByAction('GetBranchesByUserCompany', true).then(function (response) {
                decorateForSelect(response.data);
                CallingReportVM.Branches = response.data;
            });

            function decorateForSelect(arrayOfObj) {
                arrayOfObj.forEach(
                    function (obj) {
                        obj.LookupId = obj.CompanyBranchId;
                        obj.VisibleValue = obj.BranchName;
                        obj.HiddenValue = obj.BranchCode;
                    }
                );
            }

            function toggle() {
                $mdSidenav("ExportSideNav")
                    .toggle()
                    .then(function () { });
            }

            CallingReportVM.exportToPdf = exportToPdf;

            function search() {
                // if(moment(new Date(CallingReportVM.FromDate)).startOf('day')>moment(new Date(CallingReportVM.ToDate)).endOf('day'))
                // {
                //       showCustomToast('error', " 'From Date' Can Not Be Greater Than 'To Date'");
                // }
                CallingReportVM.container.CallingReportGrid.dataSource.read();
                CallingReportVM.filterEnabled = true;
                exportUserId = angular.copy(CallingReportVM.UserId);
                exportFromDate = moment(new Date(CallingReportVM.FromDate)).startOf('day').toISOString().replace(/:/g, '~').replace("Z", "");
                exportToDate = moment(new Date(CallingReportVM.ToDate)).endOf('day').toISOString().replace(/:/g, '~').replace("Z", "");
                // exportFromDate=angular.copy(CallingReportVM.FromDate);
                // exportToDate=angular.copy(CallingReportVM.ToDate)
            }

            function exportToPdf() {
                var userId = exportUserId
                    ? exportUserId
                    : null;
                var fromdate = exportFromDate
                    ? exportFromDate
                    : null;
                var todate = exportToDate
                    ? exportToDate
                    : null;
                CallingReportService.exportCallingReport(userId, fromdate, todate);
            }

            //   CallingReportVM.formatDate =function(item){
            //     if(!angular.isDefined(item) || item==null || item.toString().trim()==""){
            //         return 'N/A';
            //     }
            //     // console.log(item.getUTCDate());

            //     var Date=item.getDate();
            //     var month=item.getMonth();
            //     month=month+1;
            //     var year=item.getFullYear();
            //     var time=item.toTimeString();
            //     console.log(Date+'/'+month+'/'+year+' ' +time)
            //     return Date+'/'+month+'/'+year+' ' +time;
            // }
           
            CallingReportVM.mainGridOptions = {
                dataSource: {
                    transport: {
                        read: function (o) {
                            var userId = null;
                            var fromdate = '';
                            var todate = '';

                            if (
                                angular.isUndefined(CallingReportVM.UserId) ||
                                (CallingReportVM.UserId == "")) {
                                userId = 0;
                            }
                            else {
                                userId = CallingReportVM.UserId
                                    ? CallingReportVM.UserId
                                    : null;
                            }

                            if (CallingReportVM.FromDate) {
                                fromdate = moment(new Date(CallingReportVM.FromDate)).startOf('day').toISOString().replace("Z", "");
                            }
                            // .replace(/:/g, '~')
                            if (CallingReportVM.ToDate) {
                                todate = moment(new Date(CallingReportVM.ToDate)).endOf('day').toISOString().replace("Z", "");
                            }


                            var objArgs = {
                                "userId": userId,
                                "FromDate": fromdate,
                                "ToDate": todate
                            };

                            var filters = {
                                "StoredProcedure": "sp_calling_report",
                                "Arguments": objArgs,
                                "ReportName": "Calling_Report"
                            };


                            CallingReportVM.o = angular.copy(o);
                            CallingReportVM.filters = CallingReportVM.o.data.filter;

                            firebase.logTmxEvent('report',{name:'Calling Report'});
                            CallingReportService.putByParams(o, true, "ReportDataSourceResultPost", filters).then(function (response) {

                                if (response) {
                                    CallingReportVM.GridResponseData = response.Data;
                                    o.success(response);
                                }
                            });

                            CallingReportVM.filterEnabled = true;

                        },

                        dataType: "json"
                    },
                    schema: {
                        data: "data",
                        total: "data.length",
                        // parse: function(response) {
                        //   if (response != undefined) {
                        //     response = response.data;

                        //     var invoices = [];
                        //     var invoiceNumber = [];

                        //     for (var i = 0; i < response.length; i++) {
                        //       var invoice = response[i];

                        //       invoice.InvoiceGroup =
                        //         invoice.InvoiceGroup +
                        //         " -- Date:" +
                        //         moment(invoice.InvoiceDate).format("DD/MM/YYYY") +
                        //         " -- Customer: " +
                        //         invoice.CustomerName +
                        //         " -- Status: " +
                        //         invoice.ClubbedStatus;
                        //       invoice.InvoiceDate = moment(invoice.InvoiceDate).format(
                        //         "DD-MM-YYYY"
                        //       );

                        //       if (!invoiceNumber.includes(invoice.InvoiceNumber)) {
                        //         invoices.push(invoice);
                        //         invoiceNumber.push(invoice.InvoiceNumber);
                        //       }
                        //     }


                        //     invoices = {
                        //       data: invoices
                        //     };

                        //     return invoices;
                        //   }
                        // }
                    },
                    // aggregate: [
                    //   { field: "InvoiceNumber", aggregate: "count" },
                    //   { field: "InvoiceLineTax", aggregate: "count" },
                    //   { field: "InvoiceTotalAmount", aggregate: "sum" }
                    // ],
                    // group: {
                    //   field: "InvoiceNumber",
                    //   aggregates: [
                    //     { field: "InvoiceNumber", aggregate: "count" },
                    //     { field: "InvoiceLineTax", aggregate: "count" },
                    //     { field: "InvoiceTotalAmount", aggregate: "sum" }
                    //   ]
                    // },
                    serverPaging: false,
                    serverFiltering: false,
                    serverSorting: false
                    // sort: [{ field: "InvoiceDate", dir: "desc" }]
                },
                pageable: {
                    refresh: true,
                    pageSizes: [5, 10, 15, 20, 100, "All"],
                    pageSize: 15,
                    buttonCount: 4
                },
                excel: {
                    allPages: true,
                    fileName: "CallingReport.xlsx"
                },
                excelExport: function (e) {
                    var sheet = e.workbook.sheets[0];
                    var columns = e.workbook.sheets[0].columns;
                    for (var rowIndex = 1; rowIndex < sheet.rows.length; rowIndex++) {


                        var row = sheet.rows[rowIndex];
                        // console.log(row.cells[8].value);
                        row.cells[8].value = CallingReportVM.formatDateTime(row.cells[8].value);
                        row.cells[7].value = CallingReportVM.formatDateTime(row.cells[7].value);
                    }
                    columns.forEach(function (column) {
                        delete column.width;
                        column.autoWidth = true;
                    });
                },
                sortable: true,
                scrollable: !$mdMedia("gt-sm"),

                columns: CallingReportService.GridColumns
            };
        }]);
})();
